module.exports = __webpack_public_path__ + "img/person1.3156b837.webp";